<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productPrice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productPrice.pageTitle'),
            href: '/admin/product-prices',
          },
          {
            text: $t('update'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
				<ts-loading-banner :loading="loading">
					<div>
						<div
							class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch ts-mb-3"
						>
							<input
								v-model="text_search"
								type="text"
								placeholder="Search"
								class="ts-px-3 ts-py-3 ts-placeholder-blueGray-300 ts-text-blueGray-600 ts-relative ts-bg-white ts-rounded ts-text-sm ts-border-0 ts-shadow ts-outline-none focus:ts-outline-none focus:ts-ring ts-w-full ts-pr-10"
							/>
							<span
								class="ts-z-10 ts-h-full ts-leading-snug ts-font-normal ts-absolute ts-text-center ts-text-blueGray-300 ts-bg-transparent ts-rounded ts-text-base ts-items-center ts-justify-center ts-w-8 ts-right-0 ts-pr-3 ts-py-3"
							>
								<i class="fas fa-search"></i>
							</span>
						</div>
					</div>
					<div class="ts-overflow-auto max-h">
						<table class="ts-w-full">
							<thead>
								<tr>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.barcode') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.group') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.category') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.productNameKh') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.productNameEn') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.uom') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.saleCode') }}
									</th>
									<th class="ts-uppercase text-center ts-bg-gray-200 ts-py-1 ts-px-2">
										{{ $t('productPrice.grade') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2 ts-w-32">
										{{ $t('productPrice.cost') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2 ts-w-32">
										{{ $t('productPrice.dealerPrice') }}
									</th>
									<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2 ts-w-32">
										{{ $t('productPrice.salePrice') }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(r, index) in resourcesList" :key="index">
									<td class="ts-py-1 ts-px-2">{{ r.barcode }}</td>
									<td class="ts-py-1 ts-px-2">{{ r.pro_group_name }}</td>
									<td class="ts-py-1 ts-px-2">{{ r.category_name_en }}</td>
									<td class="ts-py-1 ts-px-2">{{ r.product_name_kh }}</td>
									<td class="ts-py-1 ts-px-2">{{ r.product_name_en }}</td>
									<td class="ts-py-1 ts-px-2">{{ r.uom_name_en }}</td>
									<td class="ts-py-1 ts-px-2">{{ r.sale_code }}</td>
									<td class="ts-py-1 ts-px-2 text-center">
										{{ r.grade }}
									</td>
									<td class="ts-py-1 ts-px-2">
										<input
											type="number"
											step="any"
											ref="cost"
											v-model.number="r.cost"
											@keypress.enter="onCostMoveNext(index)"
											@focus="$event.target.select()"
											:class="{'is-invalid': errors.has('product_sale_code_list.' + index + '.cost')}"
											class="ts-w-32 ts-border ts-border-gray-500 ts-rounded-sm ts-py-1 ts-px-2"
										/>
										<div class="invalid-feedback" v-if="errors.has('product_sale_code_list.' + index + '.cost')">
											{{ errors.first('product_sale_code_list.' + index + '.cost') }}
										</div>
									</td>
									<td class="ts-py-1 ts-px-2">
										<input
											type="number"
											step="any"
											ref="dealer_price"
											@keypress.enter="onMoveDealerNext(index)" 
											@focus="$event.target.select()"
											v-model.number="r.dealer_price"
											:class="{'is-invalid': errors.has('product_sale_code_list.' + index + '.dealer_price')}"
											class="ts-w-32 ts-border ts-border-gray-500 ts-rounded-sm ts-py-1 ts-px-2"
										/>
										<div class="invalid-feedback" v-if="errors.has('product_sale_code_list.' + index + '.dealer_price')">
											{{ errors.first('product_sale_code_list.' + index + '.dealer_price') }}
										</div>
									</td>
									<td class="ts-py-1 ts-px-2">
										<input
											type="number"
											step="any"
											ref="sale_price"
											@keypress.enter="onMoveNext(index)" 
											@focus="$event.target.select()"
											v-model.number="r.sale_price"
											:class="{'is-invalid': errors.has('product_sale_code_list.' + index + '.sale_price')}"
											class="ts-w-32 ts-border ts-border-gray-500 ts-rounded-sm ts-py-1 ts-px-2"
										/>
										<div class="invalid-feedback" v-if="errors.has('product_sale_code_list.' + index + '.sale_price')">
											{{ errors.first('product_sale_code_list.' + index + '.sale_price') }}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="ts-space-x-3 ts-flex ts-justify-end ts-mt-8">
						<ts-button
							@click.prevent="$router.push({ name: 'product-price'})"
						>{{ $t('cancel') }}</ts-button>
						<ts-button 
							color="primary"
							:waiting="waiting"
							@click.prevent="onUpdate"
						>{{ $t('update') }}</ts-button>
					</div>
				</ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'productPriceUpdate',
  data() {
    return {
			errors: new Errors(),
			text_search: '',
      resources: [],
			loading: false,
			waiting: false,
			model: {
				product_sale_code_list: []
			}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    resourcesList: (vm) => {
      return vm.resources.filter(
				r => r.barcode.toLowerCase().includes(vm.text_search.trim().toLowerCase()) || 
				r.product_name_en.toLowerCase().includes(vm.text_search.trim().toLowerCase()) ||
				r.uom_name_en.toLowerCase().includes(vm.text_search.trim().toLowerCase()) || 
				r.sale_code.toLowerCase().includes(vm.text_search.trim().toLowerCase())
			)
    },
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('product/price/fetchCurrentList')
        .then((response) => {
          this.resources = response.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
	onUpdate(){
		this.waiting = true
		this.model.product_sale_code_list = []
		this.resources.forEach(element => {
			this.model.product_sale_code_list.push({
					product_price_id: element.product_price_id,
					pro_sale_code_id: element.pro_sale_code,
					sale_price: parseFloat(element.sale_price),
					dealer_price: parseFloat(element.dealer_price),
					grade: element.grade,
					cost: parseFloat(element.cost),
			})
		});
		this.$store.dispatch('product/price/update', this.model)
			.then(response => {
				this.$toasted.success(response.message)
				this.$router.push({ name: 'product-price'})
			})
			.catch(error => {
				this.errors = new Errors(error.errors)
			})
			.finally(() => {
				this.waiting = false
			})
	},
	onCostMoveNext(index){
		this.$refs.cost[index + 1].focus()
	},
	onMoveNext(index){
		this.$refs.sale_price[index + 1].focus()
	},
	onMoveDealerNext(index){
		this.$refs.dealer_price[index + 1].focus()
	}
  },
	beforeRouteLeave(to, from, next) {
    this.$store.commit('product/price/RESET_STATE')
    next()
  }
}
</script>

<style scoped>
.max-h {
  max-height: 70vh;
}
th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>